import React from 'react';
import { connect } from 'react-redux';
import { toggle } from '../Actions/SizeGuide.action';
import { translate } from '../Services/translation';

const SizeGuide = (sizeGuide) => {
  const { toggle } = sizeGuide;
  return (
    <a className="sizeguide-button" onClick={() => toggle()}>
        {translate("sizeguide.button.name")}
    </a>
)}

const mapStateToProps = state => {
    const { sizeGuide } = state;
    return {
        ...sizeGuide,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggle: () => dispatch(toggle()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SizeGuide);
